import { useId, type SVGProps } from "react";

export const WhatsAppStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({ size = 36, colors = ["#2A2D32", "#2A2D32"], ...props }) => {
  const id = useId();
  const gradientId = `gradient-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.0613 10.7865C12.8385 10.6748 11.7428 10.1363 11.5388 10.0613C11.334 9.98703 11.1855 9.95028 11.0363 10.1738C10.8885 10.3965 10.461 10.8983 10.3312 11.0468C10.2015 11.196 10.071 11.214 9.84825 11.103C9.6255 10.9905 8.907 10.7558 8.05575 9.99678C7.3935 9.40578 6.94575 8.67603 6.816 8.45253C6.68625 8.22978 6.8025 8.10903 6.9135 7.99803C7.014 7.89828 7.137 7.73778 7.248 7.60803C7.35975 7.47753 7.3965 7.38453 7.4715 7.23528C7.54575 7.08678 7.509 6.95703 7.45275 6.84528C7.3965 6.73353 6.951 5.63628 6.76575 5.19003C6.58425 4.75578 6.4005 4.81503 6.264 4.80753C6.13425 4.80153 5.98575 4.80003 5.8365 4.80003C5.688 4.80003 5.4465 4.85553 5.2425 5.07903C5.0385 5.30178 4.4625 5.84103 4.4625 6.93828C4.4625 8.03478 5.26125 9.09453 5.37225 9.24378C5.484 9.39228 6.94425 11.6438 9.18 12.609C9.71175 12.8385 10.1265 12.9758 10.4505 13.0778C10.9845 13.248 11.4705 13.224 11.8538 13.1663C12.282 13.1025 13.1723 12.627 13.3583 12.1065C13.5443 11.586 13.5443 11.1398 13.488 11.0468C13.4325 10.9538 13.2848 10.8983 13.0613 10.7865ZM8.99475 16.3388H8.99175C7.66408 16.3389 6.36081 15.9819 5.2185 15.3053L4.94775 15.1448L2.142 15.8813L2.8905 13.1453L2.71425 12.8648C1.97208 11.683 1.57946 10.3153 1.58175 8.91978C1.5825 4.83228 4.90875 1.50678 8.99775 1.50678C10.9777 1.50678 12.8393 2.27928 14.2388 3.68028C14.9293 4.36774 15.4766 5.18533 15.849 6.08571C16.2214 6.9861 16.4116 7.95141 16.4085 8.92578C16.4063 13.0133 13.0807 16.3388 8.99475 16.3388ZM15.3045 2.61603C14.4781 1.78422 13.4949 1.12468 12.4118 0.675631C11.3287 0.226579 10.1673 -0.00305719 8.99475 3.07332e-05C4.0785 3.07332e-05 0.07725 4.00128 0.075 8.91903C0.075 10.491 0.48525 12.0255 1.266 13.3778L0 18L4.72875 16.7595C6.03644 17.472 7.50183 17.8453 8.991 17.8455H8.99475C13.9102 17.8455 17.9123 13.8443 17.9145 8.92578C17.9181 7.75374 17.6893 6.59261 17.2413 5.50956C16.7933 4.42651 16.135 3.44303 15.3045 2.61603Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="18"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const MailStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({
  size = 36,
  colors = ["#2A2D32", "#2A2D32"],
  strokeWidth = 0.7,
  ...props
}) => {
  const id = useId();
  const gradientId = `gradient-${id}`;
  const stroke = strokeWidth != null ? Number(strokeWidth) : 0;
  const pad = stroke / 2;
  const viewBox = stroke
    ? `${-pad} ${-pad} ${18 + stroke} ${13 + stroke}`
    : "0 0 18 13";
  const paint = `url(#${gradientId})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0345 2.39559L12.0439 7.18048L16.9942 11.475C17.0205 11.39 17.0345 11.2999 17.0345 11.2071L17.0345 2.39559ZM1.632 12.0887C1.68366 12.0983 1.73795 12.1035 1.7931 12.1035H16.1379C16.2027 12.1035 16.2658 12.0965 16.327 12.0834L11.3942 7.80371L10.5064 8.65474C9.83227 9.30176 8.77548 9.32278 8.07678 8.7029L7.02089 7.76781L1.632 12.0887ZM1.7931 0.896552C1.48754 0.896552 1.217 1.04977 1.05502 1.28355L8.67122 8.03212C9.02057 8.34118 9.5494 8.33154 9.88648 8.0076L16.8847 1.29669C16.7245 1.05592 16.4496 0.896556 16.1379 0.896556L1.7931 0.896552ZM0.896552 11.2069C0.896552 11.3067 0.913187 11.4021 0.942955 11.4914L6.33975 7.16446L0.896558 2.34101L0.896552 11.2069ZM17.931 11.2069C17.931 12.1971 17.1282 13 16.1379 13H1.7931C0.802862 13 0 12.1971 0 11.2069V1.7931C0 0.802862 0.802862 0 1.7931 0H16.1379C17.1282 0 17.931 0.802862 17.931 1.7931V11.2069Z"
        fill={paint}
        stroke={stroke ? paint : undefined}
        strokeWidth={stroke || undefined}
        strokeLinejoin={stroke ? "round" : undefined}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="18"
          y2="13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Filled circle used for initial / progress / action_required transaction status. */
export const StatusCircleIcon: React.FC<
  SVGProps<SVGSVGElement> & { size?: number; color?: string }
> = ({ size = 10, color = "#6b6b6b", className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="5" cy="5" r="5" fill={color} />
  </svg>
);

type StatusMarkIconProps = SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};

/** Circle + three dots — pending / created status. */
export const StatusPendingIcon: React.FC<StatusMarkIconProps> = ({
  size = 10,
  color = "#F28D19",
  className,
  ...props
}) => {
  const clipId = `status-pending-clip-${useId()}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8.30824 8.30824"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <circle cx="4.15412" cy="4.15412" r="4.15412" fill={color} />
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M4.02974 4.40587C4.16879 4.40587 4.28151 4.29315 4.28151 4.15411C4.28151 4.01506 4.16879 3.90234 4.02974 3.90234C3.8907 3.90234 3.77798 4.01506 3.77798 4.15411C3.77798 4.29315 3.8907 4.40587 4.02974 4.40587Z"
          stroke="white"
          strokeWidth="0.503529"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.7921 4.40587C5.93114 4.40587 6.04386 4.29315 6.04386 4.15411C6.04386 4.01506 5.93114 3.90234 5.7921 3.90234C5.65305 3.90234 5.54033 4.01506 5.54033 4.15411C5.54033 4.29315 5.65305 4.40587 5.7921 4.40587Z"
          stroke="white"
          strokeWidth="0.503529"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.26739 4.40587C2.40644 4.40587 2.51915 4.29315 2.51915 4.15411C2.51915 4.01506 2.40644 3.90234 2.26739 3.90234C2.12834 3.90234 2.01562 4.01506 2.01562 4.15411C2.01562 4.29315 2.12834 4.40587 2.26739 4.40587Z"
          stroke="white"
          strokeWidth="0.503529"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="6.04235"
            height="6.04235"
            fill="white"
            transform="translate(1.00781 1.13281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

/** Circle + X — failed / cancelled / expired status. */
export const StatusFailedIcon: React.FC<StatusMarkIconProps> = ({
  size = 10,
  color = "#FF3B30",
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 8.30824 8.30824"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
    {...props}
  >
    <circle cx="4.15412" cy="4.15412" r="4.15412" fill={color} />
    <path
      d="M5.28718 2.89453L2.76953 5.41218M2.76953 2.89453L5.28718 5.41218"
      stroke="white"
      strokeWidth="0.503529"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Outlined card + cancel X for the Discard interstitial.
 * Long edge is `size`; height keeps the 40×33 viewBox so the glyph is not stretched.
 * Stroke follows theme `colors`.
 */
export const DiscardCardIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
  }
> = ({ size = 65, colors = ["#2A2D32", "#2A2D32"], ...props }) => {
  const id = useId();
  const gradientId = `discard-card-gradient-${id}`;
  const stroke = `url(#${gradientId})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M27.9557 21.6439L36.9739 30.6621M36.9739 21.6439L27.9557 30.6621M37.8758 10.822H1.80273M37.8758 14.4293V7.5754C37.8758 5.55512 37.8758 4.54498 37.4826 3.77334C37.1367 3.09458 36.5849 2.54273 35.9061 2.19689C35.1345 1.80371 34.1244 1.80371 32.1041 1.80371H7.57442C5.55414 1.80371 4.544 1.80371 3.77236 2.19688C3.0936 2.54273 2.54175 3.09458 2.19591 3.77333C1.80273 4.54498 1.80273 5.55512 1.80273 7.5754V21.2831C1.80273 23.3034 1.80273 24.3136 2.19591 25.0852C2.54175 25.764 3.0936 26.3158 3.77236 26.6617C4.544 27.0548 5.55414 27.0548 7.57442 27.0548H19.8392"
        stroke={stroke}
        strokeWidth="3.6073"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="1.8"
          y1="16.5"
          x2="38"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/** Circle + exclamation — error / alert hero mark. Colors follow theme. */
export const ErrorAlertIcon: React.FC<
  SVGProps<SVGSVGElement> & { size?: number; colors?: [string, string] }
> = ({ size = 65, colors = ["#2A2D32", "#2A2D32"], className, ...props }) => {
  const id = useId();
  const paintId = `error-alert-paint-${id}`;
  const paint = `url(#${paintId})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M28.1826 40.0202C27.9708 40.0202 27.7907 39.9461 27.6425 39.7978C27.4942 39.6495 27.4201 39.4695 27.4201 39.2577V24.2609C27.4201 24.0491 27.4942 23.869 27.6425 23.7207C27.7907 23.5725 27.9708 23.4983 28.1826 23.4983H30.8198C31.0528 23.4983 31.2328 23.5725 31.3599 23.7207C31.5082 23.869 31.5823 24.0491 31.5823 24.2609V39.2577C31.5823 39.4695 31.5082 39.6495 31.3599 39.7978C31.2328 39.9461 31.0528 40.0202 30.8198 40.0202H28.1826ZM28.0555 20.7659C27.8437 20.7659 27.6637 20.6917 27.5154 20.5435C27.3671 20.3952 27.293 20.2151 27.293 20.0033V17.7157C27.293 17.5039 27.3671 17.3238 27.5154 17.1755C27.6637 17.0273 27.8437 16.9531 28.0555 16.9531H30.9468C31.1798 16.9531 31.3705 17.0273 31.5188 17.1755C31.667 17.3238 31.7412 17.5039 31.7412 17.7157V20.0033C31.7412 20.2151 31.667 20.3952 31.5188 20.5435C31.3705 20.6917 31.1798 20.7659 30.9468 20.7659H28.0555Z"
        fill={paint}
      />
      <path
        d="M28.7977 55.7477C43.6817 55.7477 55.7477 43.6817 55.7477 28.7977C55.7477 13.9136 43.6817 1.84766 28.7977 1.84766C13.9136 1.84766 1.84766 13.9136 1.84766 28.7977C1.84766 43.6817 13.9136 55.7477 28.7977 55.7477Z"
        stroke={paint}
        strokeWidth="3.696"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={paintId}
          x1="1.85"
          y1="28.8"
          x2="55.75"
          y2="28.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

/**
 * Navbar support control for `errorView` screens — same anatomy as lola
 * `SupportIcon`, but the glyph color is a prop because lola hardcodes it to
 * white, which disappears on the light disc error views use.
 */
export const SupportStrokeIcon: React.FC<
  SVGProps<SVGSVGElement> & {
    size?: number;
    colors?: [string, string];
    glyphColor?: string;
  }
> = ({
  size = 35,
  colors = ["#2A2D32", "#2A2D32"],
  glyphColor = "white",
  ...props
}) => {
  const id = useId();
  const gradientId = `support-gradient-${id}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill={`url(#${gradientId})`} />
      <path
        d="M27.0833 22.2917V18.4583C27.0833 13.1656 22.7927 8.875 17.5 8.875C12.2072 8.875 7.91663 13.1656 7.91663 18.4583V22.2917M13.1875 26.125C11.8643 26.125 10.7916 25.0523 10.7916 23.7292V20.8542C10.7916 19.531 11.8643 18.4583 13.1875 18.4583C14.5106 18.4583 15.5833 19.531 15.5833 20.8542V23.7292C15.5833 25.0523 14.5106 26.125 13.1875 26.125ZM21.8125 26.125C20.4893 26.125 19.4166 25.0523 19.4166 23.7292V20.8542C19.4166 19.531 20.4893 18.4583 21.8125 18.4583C23.1356 18.4583 24.2083 19.531 24.2083 20.8542V23.7292C24.2083 25.0523 23.1356 26.125 21.8125 26.125Z"
        stroke={glyphColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="17.5"
          x2="35"
          y2="17.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

